export default "__VITE_PUBLIC_ASSET__3631dcf8__"